var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaystack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7647_31067)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7647_31067",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.164062H30V19.8373H10V0.164062Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7647_31067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9221 0.164062H11.039C10.4675 0.164062 10 0.632461 10 1.20498V3.0786C10 3.65112 10.4675 4.11952 11.039 4.11952H27.8701C28.4416 4.11952 28.9091 3.65112 28.9091 3.0786V1.20498C28.961 0.632461 28.4935 0.164062 27.9221 0.164062ZM27.9221 10.6252H11.039C10.4675 10.6252 10 11.0936 10 11.6661V13.5397C10 14.1123 10.4675 14.5807 11.039 14.5807H27.8701C28.4416 14.5807 28.9091 14.1123 28.9091 13.5397V11.6661C28.961 11.0936 28.4935 10.6252 27.9221 10.6252ZM20.5455 15.8818H11.039C10.4675 15.8818 10 16.3502 10 16.9227V18.7963C10 19.3689 10.4675 19.8373 11.039 19.8373H20.5455C21.1169 19.8373 21.5844 19.3689 21.5844 18.7963V16.9227C21.5844 16.3502 21.1169 15.8818 20.5455 15.8818ZM28.961 5.42066H11.039C10.4675 5.42066 10 5.88906 10 6.46155V8.33521C10 8.90769 10.4675 9.37612 11.039 9.37612H28.961C29.5325 9.37612 30 8.90769 30 8.33521V6.46155C30 5.88906 29.5325 5.42066 28.961 5.42066Z",
    fill: "#0BA4DB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7647_31067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 19.6732,
    fill: "white",
    transform: "translate(0 0.164062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystack);
export default __webpack_public_path__ + "static/media/Paystack.4709711c0fdb94ce3fc42b49a1219d52.svg";
export { ForwardRef as ReactComponent };